document.addEventListener("DOMContentLoaded", () => {
  // Gestion de l'effet "Liquid Glass" dynamique au scroll
  const header = document.querySelector(".header");
  const announcementBar = document.querySelector(".announcement-bar");
  if (header) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 20) {
        header.classList.add("is-scrolled");
        if (announcementBar) announcementBar.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
        if (announcementBar) announcementBar.classList.remove("is-scrolled");
      }
    }, { passive: true });
  }

  document.querySelectorAll("[data-toggle-password]").forEach((toggle) => {
    const getInput = () => {
      const field = toggle.closest(".password-field");
      return field ? field.querySelector("input[type='password'], input[type='text']") : null;
    };

    const showPassword = () => {
      const input = getInput();
      if (!input) return;
      input.type = "text";
      toggle.classList.add("is-visible");
      toggle.setAttribute("aria-pressed", "true");
      toggle.setAttribute("aria-label", "Masquer le mot de passe");
      input.focus({ preventScroll: true });
    };

    const hidePassword = () => {
      const input = getInput();
      if (!input) return;
      input.type = "password";
      toggle.classList.remove("is-visible");
      toggle.setAttribute("aria-pressed", "false");
      toggle.setAttribute("aria-label", "Afficher le mot de passe");
    };

    toggle.addEventListener("pointerdown", (event) => {
      event.preventDefault();
      showPassword();

      const onPointerUp = () => {
        hidePassword();
        window.removeEventListener("pointerup", onPointerUp);
      };

      window.addEventListener("pointerup", onPointerUp, { once: true });
    });

    toggle.addEventListener("pointerleave", hidePassword);
    toggle.addEventListener("pointercancel", hidePassword);
    toggle.addEventListener("blur", hidePassword);

    toggle.addEventListener("keydown", (event) => {
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        showPassword();
      }
    });

    toggle.addEventListener("keyup", (event) => {
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        hidePassword();
      }
    });
  });

  const sticky = document.querySelector("[data-sticky-atc]");
  const mainAtc = document.querySelector("[data-main-atc]");
  if (!sticky || !mainAtc) return;

  const io = new IntersectionObserver(([entry]) => {
    sticky.style.display = entry.isIntersecting ? "none" : "block";
  }, { threshold: 0.2 });

  io.observe(mainAtc);

  const stickyBtn = sticky.querySelector("button[type='submit']");
  const form = document.querySelector("form[action*='/cart/add']");
  if (stickyBtn && form) {
    stickyBtn.addEventListener("click", (e) => {
      e.preventDefault();
      form.requestSubmit();
    });
  }

  // Quick Add to Cart Logic
  document.addEventListener('submit', function(e) {
    if (e.target && e.target.classList.contains('quick-add-form')) {
      e.preventDefault();
      const form = e.target;
      const btn = form.querySelector('.quick-add-btn');
      const originalText = btn.textContent;

      btn.disabled = true;
      btn.textContent = '...';

      const formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Update Cart Count
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(res => res.json())
          .then(cart => {
            const cartIcon = document.querySelector('.cart-icon-link');
            let countBadge = cartIcon.querySelector('.cart-count');
            
            if (!countBadge) {
              countBadge = document.createElement('span');
              countBadge.className = 'cart-count';
              countBadge.style.cssText = "position: absolute; top: -5px; right: -8px; background: var(--accent-primary); color: #fff; font-size: 10px; font-weight: bold; width: 18px; height: 18px; border-radius: 50%; display: flex; align-items: center; justify-content: center;";
              cartIcon.appendChild(countBadge);
            }
            countBadge.textContent = cart.item_count;

            // Success Feedback
            btn.textContent = 'Ajouté !';
            setTimeout(() => {
              btn.disabled = false;
              btn.textContent = originalText;
            }, 2000);
          });
      })
      .catch((error) => {
        console.error('Error:', error);
        btn.textContent = 'Erreur';
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2000);
      });
    }
  });

  // Close account dropdown when clicking outside
  document.addEventListener('click', function(event) {
    const wrapper = document.querySelector('.account-menu-wrapper');
    const menu = document.querySelector('.account-dropdown-menu');
    
    if (wrapper && !wrapper.contains(event.target) && menu.classList.contains('show')) {
      menu.classList.remove('show');
    }
  });
});
